import React, { useState, useEffect } from 'react';

// 🍀 응원 메시지 15개
const cheerMessages = [
  "이번엔 꼭 합격이에요. 운이 당신 쪽으로 확실히 기울었어요!",
  "이제 당신 차례예요. 그동안의 노력이 드디어 빛날 시간이 왔어요.",
  "지금까지 해온 준비, 단 1%도 헛되지 않았어요. 오늘은 그 결실의 날이에요.",
  "당신이 상상하던 '합격 문자' 오늘 진짜로 올꺼에요!",
  "운도 실력도 전부 당신 편이에요. 자신 있게 나가요!",
  "면접관은 오늘 당신을 기억할 거예요. 그만큼 당신은 준비되어 있어요.",
  "이 면접은 '운명적인 만남'이에요. 당신에게 딱 맞는 자리가 기다리고 있어요.",
  "오늘은 긴장보다 설렘으로 시작해요. 이미 결과는 좋은 방향으로 흘러가고 있어요.",
  "당신의 목소리, 눈빛, 태도 — 이미 합격자의 모습이에요.",
  "오늘의 당신은 어제보다 훨씬 멋져요. 이제 보여줄 시간이에요.",
  "작은 실수쯤은 괜찮아요. 진심이 모든 걸 이겨요.",
  "면접은 당신을 평가하는 게 아니라, 알아가는 자리예요. 편하게 해요.",
  "당신의 이야기가 누군가의 마음을 움직일 거예요. 그게 합격의 시작이에요.",
  "이 순간을 즐겨요. 당신은 이미 해낼 준비가 되어 있으니까요.",
  "합격, 이미 당신 손 안에 있어요. 마지막은 '미소'로 마무리해요."
];

function LuckyMessage({ onClose, darkMode }) {
  const [isCookieBroken, setIsCookieBroken] = useState(false);
  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  // 🆕 팝업이 열릴 때 화면을 적당한 위치로 스크롤
  useEffect(() => {
    window.scrollTo({
      top: document.documentElement.scrollHeight / 3,
      behavior: 'smooth'
    });
  }, []);

  // 🥠 쿠키 깨기!
  const handleBreakCookie = () => {
    // 랜덤 메시지 선택
    const randomMessage = cheerMessages[Math.floor(Math.random() * cheerMessages.length)];
    setMessage(randomMessage);
    
    // 쿠키 깨짐 애니메이션
    setIsCookieBroken(true);
    
    // 0.5초 후 메시지 표시
    setTimeout(() => {
      setShowMessage(true);
    }, 500);
  };

  // 🔄 다시 뽑기
  const handleReset = () => {
    setIsCookieBroken(false);
    setShowMessage(false);
    setMessage('');
  };

  const bgClass = darkMode 
    ? 'bg-gray-900 bg-opacity-95' 
    : 'bg-white bg-opacity-95';
    
  const cardClass = darkMode
    ? 'bg-gray-800 text-white'
    : 'bg-white text-gray-800';

  return (
    <div 
  className="fixed inset-0 z-50 flex items-center justify-center p-4" 
  style={{ 
    backgroundColor: 'rgba(0,0,0,0.7)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}
>
      <div className={`relative max-w-lg w-full p-8 rounded-3xl shadow-2xl ${bgClass}`}>
        
        {/* ✨ 닫기 버튼 */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl hover:scale-110 transition-transform"
        >
          ✕
        </button>

        {/* 🥠 쿠키가 안 깨졌을 때 */}
        {!isCookieBroken && (
          <div className="text-center space-y-6">
            <h2 className="text-3xl font-bold mb-4">🍀 행운의 메시지</h2>
            
            {/* 쿠키 애니메이션 */}
            <div 
              onClick={handleBreakCookie}
              className="text-9xl cursor-pointer hover:scale-110 transition-transform animate-bounce"
            >
              🥠
            </div>
            
            <p className="text-lg font-medium">쿠키를 눌러보세요!</p>
          </div>
        )}

        {/* 💥 쿠키 깨지는 애니메이션 */}
        {isCookieBroken && !showMessage && (
          <div className="text-center space-y-6">
            <div className="text-9xl animate-ping">💥</div>
            <p className="text-xl font-bold">쿠키가 열리고 있어요...</p>
          </div>
        )}

        {/* 📜 메시지 표시 */}
        {showMessage && (
          <div className="text-center space-y-6 animate-fade-in">
            <div className="text-6xl mb-4">✨</div>
            
            <div className={`p-6 rounded-2xl ${cardClass} shadow-lg`}>
              <p className="text-xl leading-relaxed font-medium whitespace-pre-line">
                {message}
              </p>
            </div>

            {/* 별 떨어지는 효과 */}
            <div className="flex justify-center space-x-2 text-3xl animate-pulse">
              <span>⭐</span>
              <span>✨</span>
              <span>💫</span>
              <span>✨</span>
              <span>⭐</span>
            </div>

            {/* 버튼들 */}
            <div className="flex gap-3 justify-center mt-6">
              <button
                onClick={handleReset}
                className="px-6 py-3 bg-purple-500 hover:bg-purple-600 text-white font-semibold rounded-xl shadow-lg transition-all"
              >
                🔄 다시 뽑기
              </button>
              <button
                onClick={onClose}
                className="px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-semibold rounded-xl shadow-lg transition-all"
              >
                닫기
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LuckyMessage;